export class BalanceBankChart {
  constructor(
    public bank: string,
    public date: string | Date,
    public balance: number,
    public percentage: number
  ) {}
}
